export default {
  dialog: {
    title: "下載調證",
  },
  common: {
    loading: "拼命加載中",
    download: "下載",
    empty: "暫無數據",
  },
  columns: {
    fileName: "文件名稱",
    uploader: "上傳人",
    uploadTime: "上傳時間",
  },
};
